import { FunctionComponent } from 'react'

import { AppProps } from 'next/app'
import dynamic from 'next/dynamic'

import DrawerPortalContainer from '@components/Drawer/DrawerPortalContainer'
import FmTHashHandler from '@components/FollowMyTeam/FmTHashHandler'
import FullScreenImagePortal from '@components/FullScreenImagePortal'
import GiftedArticleBanner from '@components/GiftedArticleBanner'
import ModalOverlayPortal from '@components/ModalOverlayPortal'
import PianoRestrictedDrawer from '@components/Piano/PianoRestrictedDrawer'
import PianoFooterBanner from '@components/PianoFooterBanner'
import ProlitterisPixelTracker from '@components/ProlitterisPixelTracker'
import Snackbars from '@components/Snackbars'
import VideoOverlayBackground from '@components/Video/VideoOverlayBackground'
import WrapperOfAll from '@components/WrapperOfAll'
import { StoryWrapType } from '@stories/utils/types'

import { CatchAllPageServerProps } from '../../pages/[[...pageUrl]]'

const BlickPlusOnboardingModal = dynamic(
  () => import('@components/BlickPlusOnboardingModal'),
  {
    ssr: false,
  },
)

export interface DefaultPageProps {
  Component: AppProps['Component']
  restOfPageProps?: Partial<CatchAllPageServerProps>
  storybookWrapType?: StoryWrapType
}

const DefaultPage: FunctionComponent<DefaultPageProps> = ({
  Component,
  restOfPageProps,
  storybookWrapType,
}) => (
  <>
    <WrapperOfAll storybookWrapType={storybookWrapType}>
      <Component {...(storybookWrapType ? {} : restOfPageProps)} />
    </WrapperOfAll>
    <FullScreenImagePortal />
    <ModalOverlayPortal />
    <DrawerPortalContainer />
    <VideoOverlayBackground />
    <Snackbars />
    <FmTHashHandler />
    {!storybookWrapType && (
      <>
        <ProlitterisPixelTracker />
        <PianoFooterBanner />
        <PianoRestrictedDrawer />
        <GiftedArticleBanner />
        <BlickPlusOnboardingModal />
      </>
    )}
  </>
)

export default DefaultPage
